import { LeftOutlined } from "@ant-design/icons";
import React from "react";
import { NavLink } from "react-router-dom";
import Timer from "../assets/images/stopwatch.png";
import { Select } from "antd";
import PLGrid from "../components/PL/pl";

const PL = () => {
  const filters = ["filter1", "filter2", "filter3"];

  return (
    <div className="min-h-screen pb-8">
      {/* Back Button */}
      <div className="mt-6 lg:mt-12 flex items-center px-4 sm:px-8 lg:px-12">
        <NavLink to="/" className="flex items-center">
          <LeftOutlined className="text-lg lg:text-xl text-primary mr-2 lg:mr-3 cursor-pointer" />
          <span className="text-primary text-xs lg:text-sm font-medium">Back</span>
        </NavLink>
      </div>

      {/* Page Title */}
      <div className="mt-6 lg:mt-8 flex items-center px-4 sm:px-8 lg:px-12">
        <img src={Timer} alt="timer" className="w-6 h-6 lg:w-8 lg:h-8 mr-3 lg:mr-4" />
        <h3 className="text-xl lg:text-2xl font-semibold text-custom-darkGray">P&L</h3>
      </div>

      {/* Filters */}
      <div className="flex flex-col sm:flex-row gap-3 lg:gap-4 mt-6 lg:mt-8 px-4 sm:px-8 lg:px-12">
        <div className="w-full sm:w-32 lg:w-36">
          <Select
            placeholder="Segment"
            className="w-full"
            size="large"
            options={filters?.map((filter) => ({
              value: filter,
              label: filter,
            }))}
          />
        </div>
        <div className="w-full sm:w-32 lg:w-36">
          <Select
            placeholder="Date Range"
            className="w-full"
            size="large"
            options={filters?.map((filter) => ({
              value: filter,
              label: filter,
            }))}
          />
        </div>
        <div className="w-full sm:w-auto">
          <button className="w-full sm:w-auto border-none py-2.5 lg:py-3 px-6 lg:px-8 rounded-lg bg-primary text-white text-sm lg:text-base font-medium cursor-pointer hover:bg-primary/80 transition-colors">
            Generate
          </button>
        </div>
      </div>

      {/* Divider */}
      <div className="w-full bg-brand-border h-[1px] mt-6 lg:mt-8"></div>

      {/* PL Grid Container */}
      <div className="flex flex-wrap gap-4 lg:gap-6 px-4 sm:px-8 lg:px-12 mt-6 lg:mt-8">
        <PLGrid />
        <PLGrid />
        <PLGrid />
        <PLGrid />
        <PLGrid />
        <PLGrid />
        <PLGrid />
        <PLGrid />
        <PLGrid />
        <PLGrid />
      </div>

      {/* Summary Stats */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-6 px-4 sm:px-8 lg:px-12 xl:px-20 mt-8 lg:mt-12">
        <div className="flex flex-col items-center sm:items-start">
          <p className="text-lg sm:text-xl lg:text-2xl font-semibold text-custom-lightRed truncate max-w-full">
            -2.4k
          </p>
          <p className="text-custom-mediumGray text-xs lg:text-sm text-center sm:text-left mt-1">
            Realized P&L
          </p>
        </div>
        <div className="flex flex-col items-center sm:items-start">
          <p className="text-lg sm:text-xl lg:text-2xl font-semibold text-custom-darkGray truncate max-w-full">
            -249.68
          </p>
          <p className="text-custom-mediumGray text-xs lg:text-sm text-center sm:text-left mt-1">
            Charges & Taxes
          </p>
        </div>
        <div className="flex flex-col items-center sm:items-start">
          <p className="text-lg sm:text-xl lg:text-2xl font-semibold text-custom-darkGray truncate max-w-full">
            -456.67
          </p>
          <p className="text-custom-mediumGray text-xs lg:text-sm text-center sm:text-left mt-1">
            Days P&L
          </p>
        </div>
        <div className="flex flex-col items-center sm:items-start">
          <p className="text-lg sm:text-xl lg:text-2xl font-semibold text-custom-lightRed truncate max-w-full">
            -3.3k
          </p>
          <p className="text-custom-mediumGray text-xs lg:text-sm text-center sm:text-left mt-1">
            Total P&L
          </p>
        </div>
        <div className="flex flex-col items-center sm:items-start col-span-2 sm:col-span-1">
          <p className="text-lg sm:text-xl lg:text-2xl font-semibold text-custom-green truncate max-w-full">
            +24.86k
          </p>
          <p className="text-custom-mediumGray text-xs lg:text-sm text-center sm:text-left mt-1">
            Total Value
          </p>
        </div>
      </div>
    </div>
  );
};

export default PL;
